import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import { Button, Tooltip } from "@material-ui/core";

let OFFSET = 0;
let LIMIT = 30;

class List extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      limit: LIMIT,
      offset: OFFSET
    };

    this.loadData = this.loadData.bind(this);

    //  PAGINATION
    this.loadNext = this.loadNext.bind(this);
    this.loadPrev = this.loadPrev.bind(this);
  }

  componentDidMount() {
    this.props.setHeader({
      title: "Fraud > Merchant Limit Configs",
      description: "SnapScan merchant limit configs"
    });
    this.loadData(0);
  }

  loadData(offset: any) {
    this.setState({ data: [], loading: true, offset: offset });
    this.props.data.fetchMore({
      variables: {
        offset: offset
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: [...fetchMoreResult.merchant_limit_configurations],
          loading: false
        });
      }
    });
  }

  loadNext() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) + parseInt(this.state.limit, 10);
    this.loadData(TMP_OFFSET);
  }
  loadPrev() {
    const TMP_OFFSET =
      parseInt(this.state.offset, 10) - parseInt(this.state.limit, 10);
    this.loadData(TMP_OFFSET);
  }

  render() {
    const list = this.state.data ? this.state.data : [];

    // Format Date
    const formatDate = date => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth() + "", 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    return (
      <section id="Ops_PaymentsList" className="padded">
        <div
          className={`loader-container ${
            this.state.loading ? "shown" : "hidden"
          }`}
        >
          <i className={`fa fa-spinner fa-spin fa-5x fa-fw`} />
        </div>
        <div
          id="setHeight"
          style={{ height: "calc(100% - 20px)", overflow: "auto" }}
        >
          <table
            style={{
              width: "100%"
            }}
            className={`BOTable`}
            cellPadding={0}
            cellSpacing={0}
          >
            <thead>
              <tr>
                <th>Date</th>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className={` ${this.state.loading ? "hidden" : "shown"} `}>
              {list.map((val, key) => {
                return (
                  <tr key={key}>
                    <td> {formatDate(val.created_at)} </td>
                    <td> {val.name}</td>
                    <td> {val.description}</td>
                    <td>
                      <Tooltip title="Summary">
                        <Button
                          onClick={() => {
                            this.props.history.push(
                              `/snapscan/fraud/merchant_limit_configs/${val.name}/summary`
                            );
                          }}
                          className="button"
                        >
                          <i className="fa fa-file-text" />
                        </Button>
                      </Tooltip>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <button
          className={
            this.state.offset === 0 || this.state.loading ? "hidden" : ""
          }
          style={{ margin: "5px", padding: "4px" }}
          onClick={this.loadPrev}
        >
          <i className="fa fa-chevron-left" />
        </button>
        <button
          style={{ margin: "5px", padding: "4px" }}
          className={list.length < 30 || this.state.loading ? "hidden" : ""}
          onClick={this.loadNext}
        >
          <i className="fa fa-chevron-right" />
        </button>
      </section>
    );
  }
}

const Currentlist = gql`
  query Currentlist($offset: Int, $limit: Int) {
    merchant_limit_configurations(offset: $offset, limit: $limit) {
      created_at
      description
      name
    }
  }
`;

const limitConfigWithGraphql = graphql(Currentlist, {
  options(props: any) {
    return {
      variables: {
        offset: OFFSET,
        limit: LIMIT
      }
    };
  }
})(List);
export default limitConfigWithGraphql;
